<template>
  <v-container fluid grid-list-md class="px-6">
    <v-app-bar color="primary" class="border" dark>
      <!-- <v-icon @click="drawer" color="white">{{HandIcon}}</v-icon> -->
      <v-app-bar-nav-icon @click.stop="updatedrawer" />
      <span class="title ml-3 mr-5">
        <!-- Google&nbsp; -->
        <span class="font-weight-regular">FlexTD</span>
      </span>
      <div class="flex-grow-1"></div>
      <v-spacer></v-spacer>
      <v-btn class="ml-2" icon color="white" dark @click="goToOrders">
        <v-icon>mdi-cart</v-icon>
      </v-btn>
      <!-- <Notifications/> -->
      <MenuUser />
    </v-app-bar>
  </v-container>
</template>

<script>
import MenuUser from "./Partials/MenuUser";
// import Notifications from "./Partials/Notifications.vue";

export default {
  components: {
    MenuUser,
    // Notifications,
  },
  methods: {
    updatedrawer() {
      let value = this.$store.getters["layout/DRAWER_STATE"];
      value = !value;
      this.$store.commit("layout/SET_DRAWER", value);
    },
    goToOrders() {
      if (this.$route.name !== "purchase_order") {
        this.$router.push({ name: "purchase_order" });
      }
    },
  },
};
</script>

<style>
.border {
  border-radius: 8px;
}
.red-point {
  background-color: red;
  width: 7px;
  height: 7px;
  border-radius: 10px;
  position: absolute;
  top: 3px;
  right: 16px;
}
</style>
